import { useState } from 'react';
import { useSelector } from 'react-redux';
import { I18n } from 'common/i18n';
import {
  showToastOnPageReload,
  showForgeErrorToastNow,
  ToastType,
} from 'common/components/ToastNotification/Toastmaster';
import { fetchJsonWithDefaultHeaders } from 'common/http';
import { useDerivedReport } from '../DerivedReportContext';
import { selectSerializedDerivedReport } from 'store/selectors/StorySelectors/StorySerialize';

export function useSaveAsNewReport() {
  const [saveInProgress, setSaveInProgress] = useState(false);
  const { currentStory, defaultStory } = useDerivedReport();
  const personalizedStoryData = useSelector(selectSerializedDerivedReport(currentStory.id));
  const parentViewId = defaultStory?.id;

  async function saveAsNew(name: string, description: string) {
    if (name) {
      personalizedStoryData.title = name;
    }
    setSaveInProgress(true);

    try {
      const result = await fetchJsonWithDefaultHeaders(
        `/stories/api/v1/stories/${parentViewId}/child_reports`,
        {
          method: 'POST',
          body: JSON.stringify({
            personalizedStoryData,
            description,
          }),
        },
      );
      showToastOnPageReload({
        type: ToastType.SUCCESS,
        content: I18n.t('derived_story.create_success_toast', { reportName: name }),
        forceEscapeContent: true,
      });
      open(`/d/${result.copy_uid}`, '_self');
    } catch (error) {
      console.error('Error creating derived story: ', error);
      setSaveInProgress(false);
      showForgeErrorToastNow(I18n.t('derived_story.create_error_toast'));
    }
  }

  return { doSave: saveAsNew, saveInProgress };
}
